import { Component } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-grant-permission-popup',
  templateUrl: './grant-permission-popup.component.html',
  styleUrls: ['./grant-permission-popup.component.scss'],
})
export class GrantPermissionPopupComponent {
  constructor(public dialogRef: MatDialogRef<GrantPermissionPopupComponent>) {}

  onCloseClick(): void {
    this.dialogRef.close();
  }
  onCancelClick(): void {
    this.dialogRef.close();
  }
}
